import React, { Component } from 'react';
import LanguageStringResolver from '../../fields/language/LanguageStringResolver';
import { SSelect } from '@avalara/skylab-sdk/react';

export class FilingLanguageSelector extends Component {
  selectionChangeHandler(event) {
    const selectedKey = event?.detail?.item?.value ?? '';
    this.props.selectionHandler(this.props.selection, selectedKey);
  }

  render() {
    let doShow =
      this.props.filingLanguages &&
      this.props.filingLanguages.length > 0 &&
      this.props.selection &&
      this.props.selection.outputType === 'PDF';

    return (
      <fieldset className="mb10" data-test="component-filing-language-selector">
        {doShow ? (
          <span data-test="dropdown-filing-language-selector">
            <label>
                <LanguageStringResolver string="filingFilingLanguage" />
            </label>
            <SSelect
              data-test="language-dropdown-control"
              inputId="filing-language-select"
              name="filingLanguage"
              onS-select={this.selectionChangeHandler.bind(this)}
              optionsList={(this.props.filingLanguages || []).map((availableLanguage) => ({
                label: availableLanguage,
                value: availableLanguage,
                selected: this.props.selectedLanguage === availableLanguage
              }))}
              multiple={false}
              showSelectionCount={false}
            />
          </span>
        ) : (
            <span data-test="empty-filing-language-selector"></span>
        )}
      </fieldset>
    );
  }
}


export default FilingLanguageSelector;
